/** Bounding box for longitude-latitude */
export class BoundingBox {

    constructor(public lonMin:number, public latMin:number, public lonMax:number, public latMax: number) { }

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/bounding-box.ts